/* angular */
import { Injectable } from '@angular/core';
import { Headers, Http, Response } from "@angular/http";
import { HttpClient, HttpHeaders } from '@angular/common/http';

/* ngx translate */
import { TranslateLoader } from '@ngx-translate/core';

/* rxjs */
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { forkJoin } from "rxjs/observable/forkJoin";

/* store */
import { Store } from '@ngrx/store';
import { getLocalizationPackages } from '../store/store';
import * as thresholdActions from '../store/actions/actions';

interface LocalizationResponse {
	key: string,
	value: string
}

@Injectable()
export class TranslateLoaderThreshold implements TranslateLoader {

	private tokenKey: string = 'authorizationData';
	private isLoggedIn: boolean;
	private token: string;

	private langChangeSubscription : Subscription;
	private localizationPackages$: Observable<any>;
	private localizationBehavior$: BehaviorSubject<any[]>;
	private contentHeader = new Headers({ "Content-Type": "application/json", "Access-Control-Allow-Origin": "*" });

	/**
	 *
	 * @param http
	 * @param store
	 */
	constructor(private httpClient: HttpClient, private store: Store<any>) {
		this.localizationPackages$ = this.store.select(getLocalizationPackages);

		this.isLoggedIn = sessionStorage.getItem(this.tokenKey) ? true : false;
		this.token = this.isLoggedIn ? sessionStorage.getItem(this.tokenKey) : null;

	}

	/**
	 *
	 */
	private getHeaders(): HttpHeaders {
		let headers = new HttpHeaders();
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'application/json');
		if (this.isLoggedIn) headers.set('Authorization', `Bearer ${this.token}`);
		return headers;
	}

	/**
	 *
	 * @param locale locale string including language and country (e.g. 'en-us')
	 */
	getTranslation(locale: string): Observable<any> {
		// Destructure locale into lang and country vars
		let [localeLang, localeCountry] = locale.split('-');

		this.langChangeSubscription = this.localizationPackages$.subscribe((langs: any) => {
			if (langs.length > 0) { this.localizationBehavior$ = new BehaviorSubject(langs); }
		})

		// Disposes the resources held by the subscription
		this.langChangeSubscription.unsubscribe();


		// fetch celine base translations
		let baseTranslations = this.httpClient.get<LocalizationResponse[]>('/assets/i18n/' + localeLang + '.json?' + process.env.config.pkgVersion);

		// array for lang translations http requests
		let httpRequests: Observable<Object>[];

		// always make base request
		httpRequests = [baseTranslations];

		// If we have language packs
		if (this.localizationBehavior$) {
			// We have at least one language
			if (this.localizationBehavior$.getValue().length > 0) {

				// loop through all our language packs
				for (let x = 0; x < this.localizationBehavior$.getValue().length; x++) {
					// Assign the current language pack
					let currentPack = this.localizationBehavior$.getValue()[x];

					// check if our locale lang is same as language pack languageCode
					if (localeLang === currentPack.languageCode) {

						// loop through the attribute sets (different lacales for language) of the language pack
						for (let y = 0; y < currentPack.attributes.length; y++) {
							let currentAttr = currentPack.attributes[y];
							// check if our country matches that of the current attribute
							if (localeCountry === currentAttr.countryCode) {
								// Dispatch action to inform micro-UI that we are laoding a language
								this.store.dispatch(new thresholdActions.LoadingLanguageAction())

								// Request language pack
								let headers = this.getHeaders();
								let httpTranslations = this.httpClient.get(
									location.protocol + '//' + location.hostname + (location.port ? ':' + location.port: '') +
										`/api/localization/messages?
										languagecode=${localeLang}
										&countrycode=${localeCountry}
										&namespace=${currentAttr.namespace}
										&brand=${currentAttr.branding}`
									, { headers });
								httpRequests.push(httpTranslations);
							}
						}
					}
				}
			}
		}

		// create new observable
		return Observable.create(observer => {

			// fork-join all http-requests into one observable result
			forkJoin(httpRequests)
				.catch(error => {
					console.error('Error occurred while running localization service');
					return Observable.throw(error);
				})
				.subscribe(httpResults => {
					let finalResult = [];

					for (let w = 0; w < httpResults.length; w++) {
						finalResult.push(httpResults[w])
					}

					// flatten json object
					observer.next(this.flattenObject(finalResult));
					// observer.next(res);

					// complete observer
					observer.complete();
				}),
				error => {
					//  failed to retrieve from api, switch to local
					// this.http.get("/assets/i18n/en.json").subscribe((res: Response) => {
					//       observer.next(res.json()); observer.complete();
					// })
				}
		});
	}

	/**
	 *
	 * @param ob
	 */
	private flattenObject(ob) {
		var toReturn = {};
		for (var i in ob) {
			if (!ob.hasOwnProperty(i)) continue;
			if ((typeof ob[i]) == 'object') {
				var flatObject = this.flattenObject(ob[i]);
				for (var x in flatObject) {
					if (!flatObject.hasOwnProperty(x)) continue;
					toReturn[x] = flatObject[x];
				}
			} else {
				toReturn[i] = ob[i];
			}
		}
		return toReturn;
	}
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/translate-loader-threshold.service.ts